﻿import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import type { ThemeConfig } from '@/types'
import { defaultTheme } from '@/config/theme'

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<ThemeConfig>({ ...defaultTheme })

  function toggleDark() {
    theme.value.darkMode = !theme.value.darkMode
    applyTheme()
  }

  function setLayoutMode(mode: ThemeConfig['layoutMode']) {
    theme.value.layoutMode = mode
  }

  function toggleCollapsed() {
    theme.value.collapsed = !theme.value.collapsed
  }

  function updateTheme(partial: Partial<ThemeConfig>) {
    Object.assign(theme.value, partial)
    applyTheme()
  }

  function applyTheme() {
    const root = document.documentElement
    if (theme.value.darkMode) {
      document.body.setAttribute('arco-theme', 'dark')
    } else {
      document.body.removeAttribute('arco-theme')
    }
    root.style.setProperty('--color-primary', theme.value.primaryColor)
    root.style.setProperty('--border-radius', theme.value.borderRadius)
  }

  function initTheme() {
    applyTheme()
  }

  return { theme, toggleDark, setLayoutMode, toggleCollapsed, updateTheme, initTheme }
})
